<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M3 5H13M3 5L6 2M3 5L6 8" stroke="white" />
    <path d="M13 11H3M13 11L10 8M13 11L10 14" stroke="white" />
</svg>
